<div class="bulk-upload">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="bulk-upload-header">
    <span class="upload-doc">Upload Documents</span>
  </div>
  <div class="download-template-container">
      <mat-card class="download-template-wrapper">
        <img [src]="fileImg" alt="file logo">
        <span class="ml-16 download-template-text">Download the Template</span>
        <mis-dropdown label="Download" (onChange)="downloadTemplate($event)"  [selectedItem]="selectedTemplate" [dropdownListWidth]="'314px'"  [data]="templateData" [searchEnabled]="false" class="justify-self-end select-download-template"></mis-dropdown>
  </mat-card>
  </div>

  <div class="files-upload-download">
    <div class="file-uploader-container" [ngClass]="{'disabled': onGoingFileUpload}">
      <app-file-drag-drop (fileSelectedCallback)="fileSelected($event)" (openModalCallback)="openModalCallback($event)" [message]="message" [fileName]="fileName" [uplaodImg]="uplaodImg" [browseLabel]="browseLabel" [showOnUploadAttempt]="showOnUploadAttempt" [isSuccess]="isSuccess"></app-file-drag-drop>
    </div>
   <!--  <div class="file-download-container">
      <div class="heading">Download the Template</div>
      <div class="download-template csv" *ngIf="bulkBookingConfigObj && bulkBookingConfigObj['MultipleBookingsSinglePickUpDrop'].visibility.visible" (click)="handleDownloadTemplateXLS()">
        <img class="download-icon" src="assets/download.svg"/>
        {{bulkBookingConfigObj['MultipleBookingsSinglePickUpDrop'].displayName}}.xls
      </div>
      <div class="download-template" *ngIf="bulkBookingConfigObj && bulkBookingConfigObj['TeamOuting'].visibility.visible" (click)="handleMultiSDownloadTemplateXLS()">
        <img class="download-icon" src="assets/download.svg"/>
        {{bulkBookingConfigObj['TeamOuting'].displayName}}.xls
      </div>
    </div> -->
  </div>
  <div class="upload-btn-container">
    <div class="uplaod-btn-content">
      <button mis-button type="primary" size="lg" class="btn-lg-height" (click)="beginDownload(uplaodBtnLabel)" [disabled]="isDisabled">{{uplaodBtnLabel}}</button>
    </div>
  </div>
  <div class="download-progress" [ngClass]="{'hide-upload': !showProgressBar}">
    <img src="assets/document-large.svg"/>
    <div class="file-details">
      <div class="file-name">{{fileName}}</div>
      <div class="upload-status">
        <div class="percent-container mt-10">
          <span class="percent">{{percentDone}}%</span>
          Uploaded
        </div>
        <div class="error-message mt-10" *ngIf="passedRows.length">
          <img class="error-icon" src="assets/tick-circle-filled.svg"/>
          {{passedRows.length}} booking(s) successfully created, Please
          <div class="error-handler-link" (click)="handlePassedBooking()">Click here</div> to view data.
        </div>
        <div class="error-message mt-10 mb-10" *ngIf="failedRows.length">
          <img class="error-icon" src="assets/error.svg"/>
          There are {{failedRows.length}} errors, Please
          <div class="error-handler-link" (click)="handleShowErrorMessage()">Click here</div> to view data.
        </div>
      </div>
      <div class="progress-bar-container mt-10">
        <div class="progress-bar-base"></div>
        <div class="progress" #progressElement></div>
      </div>
    </div>
  </div>
  <app-file-upload *ngIf="showFileUploadModal"
    [fileToUpload]="fileToUpload"
    [showFileUploadModal]="showUploadModal"
    (submitUploadReportCallback)="submitUploadReport()"
    (handleDismissUploadFileModal)="handleDismissUploadFileModal()"
    [uploadFileError]="uploadFileError">
  </app-file-upload>

  <app-popover *ngIf="showFileErrors && failedRows.length" size="large" (closeCallback)="dismissError()">
    <div popover-header class="error-header">
      <mat-icon class="error-icon-align" svgIcon="error"></mat-icon>
      Errors
    </div>
    <div popover-content class="error-table-wrapper autoscroll">
      <table class="error-table">
        <thead class="error-table-head">
          <th class="column-header group-no">Sl No.</th>
          <th class="column-header column-name row-no">Row Number</th>
          <th class="column-header column-name">Field Name</th>
          <th class="column-header">Error Description</th>
        </thead>
        <tbody class="error-table-body">
          <tr class="error-table-row" *ngFor="let error of this.failedRows; let index=index">
            <td class="ellipsis group-no">{{index+1}}</td>
            <td class="ellipsis row-no">{{error.rowNo}}</td>
            <td class="ellipsis column-name">{{error.columnName}}</td>
            <td >{{error.errorMessage}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-popover>

  <app-popover *ngIf="showFilePassed && passedRows.length" size="medium" (closeCallback)="dismissError()">
      <div popover-header class="success-header">
        Booking created successfully
      </div>
      <div popover-content class="error-table-wrapper autoscroll">
        <table class="error-table">
          <thead class="error-table-head">
            <th class="column-header">Sl No.</th>
            <th class="column-header">BookingId</th>
          </thead>
          <tbody class="error-table-body">
            <tr class="error-table-row" *ngFor="let row of this.passedRows; let index=index;">
              <td class="ellipsis file-name">{{index+1}}</td>
              <td class="ellipsis group-no">{{row.bookingId}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-popover>

  <app-toast *ngIf="showUploadSuccess" message="Upload Successful" (dismissCallback)="toggleToast()">
  </app-toast>

  <app-dialog *ngIf="showErrorDialog" titleText="File Download Error" type="alert" [buttonText]="['Okay']" (approveCallback)="dismissError()">
    {{errorMessage}}
  </app-dialog>

  <app-dialog *ngIf="showFileNameError" titleText="File Upload Error" type="alert" [buttonText]="['Okay']" (approveCallback)="dismissError()">
      {{fileUploadErrorMessage}}
  </app-dialog>
</div>